import { useGetPageQuery, useSendFormMutation } from "../../redux/services/crmAPI";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { succsesDataChangeAlert } from "../../alerts/alerts";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const CurrentModel = () => {
    const navigate = useNavigate();
    const permissions = useSelector((state) => state.status.permissions);

    const [selectedCategory, setSelectedCategory] = useState(1);
    const [featuresList, setFeaturesList] = useState([]);
    const [minPricesList, setMinPricesList] = useState([]);
    const [title, setTitle] = useState("");

    const { id } = useParams();
    const { data: model, refetch: refetchModeles } = useGetPageQuery("models/" + id);
    const { data: categorySelect } = useGetPageQuery("categories/select");
    const { data: features } = useGetPageQuery("features?per_page=100&category_id=" + selectedCategory);
    const { data: minPrices } = useGetPageQuery("min-price");
    const [sendForm, { isLoading, isError }] = useSendFormMutation();

    const sendFormHandler = async () => {
        const formData = {
            title: title,
            category_id: selectedCategory,
            features: featuresList,
            min_prices: minPricesList,
        };

        await sendForm({ body: formData, url: "models/" + id, method: "PUT" }).unwrap();
        await refetchModeles();

        if (!isError) {
            succsesDataChangeAlert();
            navigate("/models");
        }
    };

    useEffect(() => {
        if (model) {
            setFeaturesList([
                ...model.features.map((feature) => {
                    return { id: feature.id, value: feature.values.value };
                }),
            ]);
            setMinPricesList([
                ...model.min_prices.map((price) => {
                    return { id: price.id, min: price.min_prices.min, max: price.min_prices.max };
                }),
            ]);
            setTitle(model.title);
            setSelectedCategory(model.category_id);
        }
    }, [model]);

    const featureInputHandler = (e, id) => {
        if (featuresList.find((feat) => feat.id === id)) {
            const currentfeature = featuresList.find((feat) => feat.id === id);
            currentfeature.value = e.target.value;
            setFeaturesList([...featuresList.filter((feature) => feature.id !== id), currentfeature]);
        } else {
            setFeaturesList([...featuresList, { id: id, value: e.target.value }]);
        }
    };

    const minPriceInputHandler = (e, id) => {
        if (minPricesList.find((price) => price.id === id)) {
            const currentPrice = minPricesList.find((price) => price.id === id);
            currentPrice.min = +e.target.value;
            setMinPricesList([...minPricesList.filter((feature) => feature.id !== id), currentPrice]);
        } else {
            setMinPricesList([...minPricesList, { id: id, min: +e.target.value, max: 0 }]);
        }
    };

    const maxPriceInputHandler = (e, id) => {
        if (minPricesList.find((price) => price.id === id)) {
            const currentPrice = minPricesList.find((price) => price.id === id);
            currentPrice.max = +e.target.value;
            setMinPricesList([...minPricesList.filter((feature) => feature.id !== id), currentPrice]);
        } else {
            setMinPricesList([...minPricesList, { id: id, min: +e.target.value, max: 0 }]);
        }
    };

    return (
        <>
            {model && categorySelect && features && minPrices && (
                <div className="content">
                    <div id="content" className="content_card container-fluid">
                        <div className="col-12">
                            <div id="page-header">
                                <h1>{model.title}</h1>
                            </div>
                        </div>
                        <div className="form user_form" autoComplete="off">
                            <input name="id" type="hidden" value="" />
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-12 col-sm-6 col-md-6">
                                        <div className="card card-default">
                                            <div className="card-header">
                                                Інформація про модель
                                                {/* <div className="form-check float-end">
                                            <input type="checkbox" id="check_rozetka" name="rozetka" className="form-check-input" value="1" />
                                            <label className="custom-control-label" for="check_rozetka">Показувати на Rozetka</label>
                                        </div> */}
                                            </div>
                                            <div className="card-body">
                                                <div className="form-group mb-3">
                                                    <label className="form-label">Назва</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={title}
                                                        onChange={(e) => setTitle(e.target.value)}
                                                    />
                                                </div>
                                                {minPrices.map((price) => {
                                                    return (
                                                        <div className="form-group mb-3" key={price.id}>
                                                            <label className="form-label">{price.title}</label>
                                                            <div className="float-end w_time">від 0 грн</div>
                                                            <div className="row">
                                                                <div className="col-6">
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        value={
                                                                            minPricesList.find(
                                                                                (minPrice) => minPrice.id === price.id
                                                                            )?.min
                                                                        }
                                                                        onChange={(e) =>
                                                                            minPriceInputHandler(e, price.id)
                                                                        }
                                                                    />
                                                                </div>
                                                                <div className="col-6">
                                                                    <input
                                                                        type="number"
                                                                        className="icon_locked_phone form-control"
                                                                        value={
                                                                            minPricesList.find(
                                                                                (minPrice) => minPrice.id === price.id
                                                                            )?.max
                                                                        }
                                                                        onChange={(e) =>
                                                                            maxPriceInputHandler(e, price.id)
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                                <div id="models_categories">
                                                    <label className="form-label">Категорія</label>
                                                    <select
                                                        className="form-select"
                                                        onChange={(e) => setSelectedCategory(e.target.value)}
                                                        value={selectedCategory}
                                                    >
                                                        {categorySelect.map((selectCategory) => {
                                                            return (
                                                                <option
                                                                    value={selectCategory.id}
                                                                    key={selectCategory.id}
                                                                >
                                                                    {"\u00A0\u00A0\u00A0\u00A0\u00A0".repeat(
                                                                        selectCategory.level
                                                                    ) + selectCategory.title}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        {permissions.includes("model_edit") || permissions.includes("all") ? (
                                            <div className="saves_block">
                                                <button
                                                    name="user_info"
                                                    className="btn btn-primary"
                                                    onClick={sendFormHandler}
                                                >
                                                    {isLoading ? "Завантаження" : "Зберегти"}
                                                </button>
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-6">
                                        <div className="card card-default">
                                            <div className="card-header">Характеристики</div>
                                            <div className="card-body">
                                                <ul className="prop_ul text-decoration-none">
                                                    {features.data.map((feature) => {
                                                        return (
                                                            <li className="mb-3" key={feature.id}>
                                                                <div className="form-group row">
                                                                    <label className="property col-sm-4 control-label">
                                                                        {feature.title}
                                                                    </label>
                                                                    <div className="col-sm-8">
                                                                        <input
                                                                            className="form-control"
                                                                            type="text"
                                                                            autoComplete="off"
                                                                            onChange={(e) =>
                                                                                featureInputHandler(e, feature.id)
                                                                            }
                                                                            value={
                                                                                featuresList?.find(
                                                                                    (feat) => feat.id === feature.id
                                                                                )?.value
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div className="clearfix"></div>
                                                                </div>
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default CurrentModel;
